import {useEffect,useState} from 'react'
import { ViewModalHeader } from './ViewModalHeader'
import { getOneServerLog , createOneServerLog, UpdateOneServerLog } from '../request/request'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo'

const CreateSyslog = ( props:any ) => {

  const [ showDemoModal , setshowDemoModal ] = useState<undefined | null | number>(undefined)

  const TenantId = useAppSelector(state =>state.TenantSlice.id) //tenant id (solo visible para super admin)
  const SubscriptionId = useAppSelector(state => state.SuscriptionSlice.id) //subscrition id puede ser un id o -1 para mostrar todas las suscripciones


  //user logeado
  const{currentUser} = useAuth();

  //estados para el form 
  const [ServerIP,setServerIP] = useState('');
  const [ServerPort,setServerPort] = useState('');
  const [SyslogDescription,setSyslogDescription] = useState('');

  const resetForm = () => {
    // Restablece los estados aquí, por ejemplo:
    setServerIP('');
    setServerPort('');
    setSyslogDescription('');
  };
 
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    //colocar llamada al ep de ticket for id 
    const fetchData = async () => {
      try {
          if( props.id !== "" && props.id !==null ){
            const {data} = await getOneServerLog(SubscriptionId, props.id, TenantId)
            setServerIP(data.ip);
            setServerPort(data.port);
            setSyslogDescription(data.description);
          }
        } catch (error) {
          console.error('Error al obtener los permisos', error);
      }
    };
      fetchData();
  }, [props.id])


    const handleSubmit =async (e:any) => {
    e.preventDefault();
      if(SubscriptionId === -1){
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'It cannot be created in the global subscription, please select in the menu the specific subscription where you want the syslog server to be created.',
          showConfirmButton: false,
          timer: 3500
          })
          return 
      }
    try{
      if(ServerIP === ""){
        Swal.fire({
          icon: 'error',
          title: 'Please fill in the IP field.'
          });
          return
      }
      if(ServerPort === ""){
        Swal.fire({
          icon: 'error',
          title: 'Please fill in the Port field.'
          });
          return
      }
      if(SyslogDescription === ""){
        Swal.fire({
          icon: 'error',
          title: 'Please fill in the Description field.'
          });
          return
      }
      setLoading(true)
      if(props.id ===null){
        const body ={
          ip: ServerIP,
          port: Number(ServerPort),
          description: SyslogDescription
        }
        try {
          const response = await createOneServerLog(SubscriptionId, body, TenantId ) 
          //console.log("response ", response)
          if(response.status === 200){
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Your syslog server has been created.',
              showConfirmButton: false,
              timer: 3000
            })
            props.setID(undefined)
            resetForm()
          }
        }catch(error:any){
          console.log(error.response)
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'The syslog server could not be created.\n error code: ' + error.response.status +'\nerror message: ' + error.response.data.error,
              showConfirmButton: false,
              timer: 3500
            })
        }
        
      }else{
        const body ={
          ip: ServerIP,
          port: Number(ServerPort),
          description: SyslogDescription
        }
        const response = await UpdateOneServerLog(SubscriptionId, props.id, body, TenantId ) 
        if(response.status === 200){
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your syslog server has been created.',
            showConfirmButton: false,
            timer: 1500
          })
          props.setID(undefined)
          resetForm()
        }else{
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'The syslog server could not be created.\n error code: ' + response.status,
            showConfirmButton: false,
            timer: 1500
          })
        }
      }

    }catch(error:any){
      console.log(error)
    }finally {
      setLoading(false)
      props.reload()
    }
   }

  
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])


  return (<>
    {<div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
              {/* begin::Heading */}
              <div className='text-center mb-5'>
              <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'> {props.id === null ? "Add" : "Edit"} Syslog Server</h1>
              </div>
              {/* begin::Heading */}
      
              {/* begin::Login options */}

          
              {/* Campos solicitud */}
              <br />
              <div className='row'>
                <div className='col'>
                  <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="name">Server IP <span>*</span></label>
                  <input type="text" 
                  name='name' 
                  className='form-control form-control-solid border border-gray-300 f-parrafo' 
                  id='ServerIP'
                  value={ServerIP}
                  onChange={(e:any) => setServerIP(e.target.value)}
                  />
                </div>
                <div className='col'>
                  <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo ' htmlFor="descripcion">Port *</label>
                  <input type="text" 
                  name='name' 
                  className='form-control form-control-solid border border-gray-300 f-parrafo' 
                  id='ServerPort'
                  value={ServerPort}
                  onChange={(e:any) => setServerPort(e.target.value)}
                  />
                </div>
                <div className='col'>
                  <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo ' htmlFor="descripcion">Description</label>
                  <input type="text" 
                  name='name' 
                  className='form-control form-control-solid border border-gray-300 f-parrafo' 
                  id='Description'
                  value={SyslogDescription}
                  onChange={(e:any) => setSyslogDescription(e.target.value)}
                  />
                </div>
              </div>
              <div>
                  <br />
              </div>

              {currentUser?.is_demo!==true&&
              <div className='d-grid mb-10 justify-content-center'>
                <div className='row'>
                  <div className='col'>
                      <button
                      type='submit'
                      id='kt_sign_in_submit'
                      className='btn btn-primary'
              
                      
                    >
                      {!loading && <span className='indicator-label'>Save</span>}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                  <div className='col'>
                    <button
                    className='btn-cancel btn border border-pink text-pink f-parrafo'
                    style={{width:'200px'}}
                    onClick={() => props.setID(undefined)}

                    >
                      Cancel
                    </button>
                  </div>
                </div>
                
                
              </div>}
              {/* end::Action */}

          </form>
          {currentUser?.is_demo===true&& <div className="d-flex justify-content-center">
            <button  onClick={()=>setshowDemoModal(null)} type='submit' id='kt_sign_in_submit'
                >Add</button> 

            </div>}
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }   
      {showDemoModal !== undefined && <DemoModal setID={setshowDemoModal} id={showDemoModal} />}
    </>
  )
}
export {CreateSyslog}